import React from 'react'
import PropTypes from 'prop-types'

import { NavLink } from '../../components'
import getSiteSection from '../../helpers/getSiteSection'

const createPath = (link, text) =>
  encodeURI(
    `${link}&clickOrigin=header:${getSiteSection()}${text
      .replace(/ /g, '+')
      .replace(/[&']/g, '')
      .toLowerCase()}`,
  )

const handleMegaButtonRoute = (evt, idx, routes, href, closeNav) => {
  if (routes.megaButtons && routes.megaButtons[idx] && typeof routes.megaButtons[idx] === 'function') {
    evt.preventDefault()
    closeNav(evt)
    routes.megaButtons[idx].call(this, href)
  }
}

const MegaButtons = ({ links, routes, className, closeNav }) =>
  links && links.length > 0
    ? links.map((link, idx) => {
        const href = createPath(link.link, link.text)
        return (
          <NavLink
            key={`${link.text}${idx}`}
            className={className}
            href={href}
            id={`megabutton${idx}`}
            text={link.text}
            onClick={(evt) => handleMegaButtonRoute(evt, idx, routes, href, closeNav)}
          />
        )
      })
    : null

MegaButtons.defaultProps = {
  links: [],
  routes: {},
  className: {},
}

MegaButtons.propTypes = {
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  closeNav: PropTypes.func,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundColor: PropTypes.string,
      borderColor: PropTypes.string,
      icon: PropTypes.bool,
      link: PropTypes.string,
      text: PropTypes.string,
      textColor: PropTypes.string,
    }),
  ),
  routes: PropTypes.shape({
    help: PropTypes.func,
    stores: PropTypes.func,
    search: PropTypes.func,
    megabuttons: PropTypes.arrayOf(PropTypes.func),
  }),
}

export default MegaButtons
